
























import KeyName from "@/components/KeyName.vue";
import ButtonCard from "@/components/ButtonCard.vue";
import PrefixItemStats from "@/components/PrefixItemStats.vue";
import { Prefix } from "@/types/debug-mode";
import { NotificationType, Issue } from "@/types/notification";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({
  components: {
    KeyName,
    ButtonCard,
    PrefixItemStats,
  },
})
export default class PrefixItem extends Vue {
  @Getter("debugMode/prefixIssues") issues!: (prefixID: number) => { [propName: string]: Issue };

  @Prop({ required: true })
  prefix!: Prefix;

  @Prop({ required: false, default: false })
  isDisabled!: boolean;

  get issue(): Issue | false {
    if (Object.keys(this.issues(this.prefix.id)).length > 0) {
      return {
        type: NotificationType.WARNING,
        message: "Issues found, view prefix to learn more",
        icon: "exclamation-circle",
      };
    }
    return false;
  }

  showStats() {
    if (this.isDisabled) return;

    this.$router.push({
      name: "prefixOverview",
      params: { prefixId: this.prefix.id.toString() },
    });
  }
}
